import { render, staticRenderFns } from "./EditBlogbook.vue?vue&type=template&id=3b6cb229&scoped=true&"
import script from "./EditBlogbook.vue?vue&type=script&lang=js&"
export * from "./EditBlogbook.vue?vue&type=script&lang=js&"
import style0 from "./EditBlogbook.vue?vue&type=style&index=0&id=3b6cb229&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6cb229",
  null
  
)

export default component.exports